import $ from "jquery";

$(function () {
    const active_li = $('.active');
    const collapse = $('.collapse');
    collapse.children('.sidenav').slideUp(0);
    active_li.children('.sidenav').slideDown(0);
    collapse.children('.sidenav_link').attr('c', 0);
    active_li.children('.sidenav_link').attr('c', 1);
});
export function sidenav_toggle($e) {
    const _this = $($e.target);
    if (_this.attr('c') == 0) {
        _this.siblings('.sidenav').slideDown();
        _this.attr('c', 1);
    } else if (_this.attr('c') == 1) {
        _this.siblings('.sidenav').slideUp();
        _this.attr('c', 0);
    }
};